/*eslint-disable */
import React, { Component } from "react";
import {
  Grid,
  Header,
  Icon,
  Button,
  Dropdown,
  Divider,
} from "semantic-ui-react";
import OrderDetailsHeader from "./OrderDetailsHeader";
import ReadAxios from "../../axiosComponent/read";
import PdfAxios from "../../axiosComponent/downloadpdf";
import FileCreatAxios from "../../axiosComponent/fileupload";
import LoadingPlaceholder from "../../placeholderComponent/loadingPlaceholder";
import ShipmentOrderTable from "./shipmentOrderTable";
import { translate } from "react-i18next";
import VendorRepliesTable from "./vendorRepliesTable";
import FormikPickup from "../modals/pickupModal";
import FormikStatusChange from "../modals/statusChange";
import StatusHistory from "../modals/statusHistory";
import FormikDropDetails from "../modals/deliveryModal";
import { Form as Formiker, Field as Fieldmik, Formik } from "formik";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { connect } from "react-redux";
import moment from "moment";
import AddPod from "../modals/podModal";
import "moment-timezone";
import ViewPod from "../modals/viewPod";
import EditVendorLrNoModal from "../modals/editVendorLrNoModal";
import DeliveryDetailComponentRebuilt from "./DeliveryDetailComponentRebuilt";
import {Headings} from "../../../utils/constants/reportingOrderDetails.constants"

class ReportingOrderDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      networkProviderList: [],
      trackingTypeMasterList: [],
      orderDetail: null,
      routeDetails: null,
      deliverySD: "",
      blList: [],
      bldocuments: [],
      broadcastDetails: null,
      orderDetail: null,
      order: null,
      deliveryDetails: null,
      serviceType: null,
      files: [],
      deliveries: null,
      podModal: false,
      broadcastTimeLeft: null,
      // current_order: null,
      updateDoc: "",
      shipmentId: "",
      shipmentDetail: [],
      current_bl: null,
      show_current_bl: null,
      podModal: false,
      viewPodModal: false,
      historyModal: false,
      mystyle: {
        display: "table-cell",
        opacity: "1",
        verticalalign: "middle",
      },
    };
  }

  //   TODO: make both at same time
  async componentDidMount() {
    // console.log(this.props.location);
    let orderId = this.props.location.search.split("=")[1];
    //TODO: null handling for api call
    let vendorId = localStorage.getItem("vendorId");
    let results = await ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${orderId}/vendor/${vendorId}`,
    })
      .then((res) => {
        this.setState({
          orderDetail: res.data.result,
          shipmentId: res.data.result.shipment.vendor_shipment_id,
          broadcastDetails: res.data.result.broadcast,
          routeDetails: res.data.result.route_details,
          serviceType: res.data.result.service_type,
          deliveryDetails: res.data.result.deliveries,
          forceUpdate: false,
        });
        this.getBlList(orderId);
        let delivery_array = [];
        let delivery_details = res.data.result.deliveries;
        if (delivery_details) {
          for (const key in delivery_details) {
            if (delivery_details.hasOwnProperty(key)) {
              const element = delivery_details[key];
              delivery_array.push(element);
            }
          }
        }
        this.setState({
          deliveries: delivery_array,
        });
      })
      .catch((err) => {
        console.log(err);
      });

    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/shipments/${this.state.shipmentId}`,
    })
      .then((res) => {
        this.setState({
          shipmentDetail: res.data.shipment.documents,
        });
        if (this.state.shipmentDetail) {
          for (const key in this.state.shipmentDetail) {
            if (this.state.shipmentDetail.hasOwnProperty(key)) {
              const element = this.state.shipmentDetail[key];
              this.setState({
                documents: element,
              });
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });

    ReadAxios({
      url: `networkProviderMaster`,
    })
      .then((res) => {
        if (res.status === 200) {
          let networkProvider = res.data.resultSet.map((item, index) => {
            return {
              key: index + 1,
              value: item.networkProviderMasterId,
              text: item.networkProviderName,
              raw: { ...item },
            };
          });
          this.setState({
            networkProviderList: networkProvider,
          });
        } else {
          //cogoToast.error(res.status);
          console.log(res.status);
        }
      })
      .catch((err) => {
        let error_msg = err.response ? err.response.data.message : err.message;
        //cogoToast.error(error_msg);
        console.log(error_msg);
      });

    ReadAxios({ url: `trackingTypeMaster` })
      .then((res) => {
        if (res.status === 200) {
          let trackingTypeMaster = res.data.resultSet.map((item, index) => {
            return {
              key: index + 1,
              value: item.trackingTypeId,
              text: item.trackingType,
              raw: { ...item },
            };
          });
          this.setState({
            trackingTypeMasterList: trackingTypeMaster,
          });
        } else {
          //cogoToast.error(res.status);
          console.log(res.status);
        }
      })
      .catch((err) => {
        let error_msg = err.response ? err.response.data.message : err.message;
        //cogoToast.error(error_msg);
        console.log(error_msg);
      });
  }

  getDocType = (type) => {
    if (this.state.bldocuments && this.state.bldocuments.length > 0 && type) {
      for (const docType of this.state.bldocuments) {
        var docT = docType.doc_type;
        var shipDocId = docType.filename;
        if (type == docT) {
          return type == docT;
        }
      }
    }
  };

  getDocs = (type) => {
    if (this.state.bldocuments && this.state.bldocuments.length > 0) {
      var arr = [];
      var count = [];
      for (const docType of this.state.bldocuments) {
        var docT = docType.doc_type;
        var shipDocName = docType.filename;
        var shipDocId = docType.shipment_doc_id;
        if (type == docT) {
          count.push({ id: shipDocId, name: shipDocName });
        }
      }
      arr.push({ data: count });
      return count;
    }
  };

  getDocs = (type) => {
    if (this.state.bldocuments && this.state.bldocuments.length > 0) {
      var arr = [];
      var count = [];
      for (const docType of this.state.bldocuments) {
        var docT = docType.doc_type;
        var shipDocName = docType.filename;
        var shipDocId = docType.shipment_doc_id;
        if (type == docT) {
          count.push({ id: shipDocId, name: shipDocName });
        }
      }
      arr.push({ data: count });
      console.log("COUNT : ", count, arr);
      return count;
    }
  };

  getfileName = (type) => {
    if (this.state.bldocuments && this.state.bldocuments.length > 0) {
      for (const docType of this.state.bldocuments) {
        var docT = docType.doc_type;
        var shipFileNeame = docType.filename;
        if (type == docT) {
          return shipFileNeame;
        }
        // return shipDocId
      }
    }
  };
  getDocId = (type) => {
    if (this.state.bldocuments && this.state.bldocuments.length > 0) {
      for (const docType of this.state.bldocuments) {
        var docT = docType.doc_type;
        var shipDocId = docType.shipment_doc_id;
        if (type == docT) {
          return shipDocId;
        }
      }
    }
  };

  getBlList = (order) => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${order}/bl/list`,
    })
      .then((res) => {
        let tempArray = [];
        let info = res.data.data;
        tempArray = info.split(",");
        let bLOptions = tempArray.map((item, index) => {
          return {
            key: index,
            value: item,
            text: item,
            raw: { item },
          };
        });
        this.setState({
          blList: bLOptions,
          current_bl: bLOptions[0].key,
        });
        // console.log('check current bl', this.state.blList[this.state.current_bl].value);
        this.setState({
          show_current_bl: this.state?.blList[this.state.current_bl]?.value,
        });
        ReadAxios({
          completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/bl/${this.state.show_current_bl}/documents`,
        })
          .then((res) => {
            console.log(res.data.data);
            this.setState({
              bldocuments: res.data.data,
            });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  setCurrentBLToShow = (name, data) => {
    this.setState({
      current_bl: data.options.find((ele) => ele.value === data.value).key,
      show_current_bl: data.value,
    });
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/bl/${data.value}/documents`,
    })
      .then((res) => {
        console.log(res.data.data);
        this.setState({
          bldocuments: res.data.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  downloadFile = (id) => {
    setTimeout(() => {
      console.log(id);
    }, 2000);

    PdfAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/bl/${this.state.show_current_bl}/documents/${id}/download`,
    })
      .then((res) => {
        // let link = res.data;
        // link.setAttribute(link)
      })
      .catch((err) => {
        console.log(err);
      });
  };
  handlePodModal = () => {
    this.setState({
      podModal: true,
    });
  };
  handlePodModalClose = () => {
    this.setState({
      podModal: false,
    });
  };

  handleHistoryModal = (deliveries) => {
    this.setState({
      deliverySD: deliveries,
      historyModal: true,
    });
  };
  handleHistoryModalClose = () => {
    this.setState({
      historyModal: false,
    });
  };

  setCurrentOrderToShow = (name, data) => {
    this.setState({
      current_order: data.options.find((ele) => ele.value === data.value).key,
    });
  };

  uploadFile = (id) => {
    document.getElementById(id).click();
  };

  handleViewPodModal = () => {
    this.setState({
      viewPodModal: true,
    });
  };
  updateFile = (name, id, value) => {
    let values = { [name]: value };
    FileCreatAxios({
      url: `${process.env.REACT_APP_TA_API_URL}/shipments/${id}/update-file`,
      payload: { ...values },
    })
      .then((res) => {
        this.props.success({
          type: "success",
          messageHeader: "Success",
          messageBody: "File Updated Successfully",
        });
        // window.location.reload();
      })
      .catch((err) => {
        this.props.error({
          type: "error",
          messageHeader: "Error",
          messageBody: err.response.data.error,
        });
        window.location.reload();
      });
  };

  getrefertype(reefer_type_and_model) {
    let refer_type;
    let refer_items = [
      { key: "1", text: "OASIS 150 (12FT -20 D)", value: "1" },
      { key: "2", text: "SUPRA 550 (14FT - 20 D)", value: "2" },
      { key: "3", text: "OASIS 250 (20FT -20 D)", value: "3" },
      { key: "4", text: "SUPRA 850 (22FT-20 D)", value: "4" },
      { key: "5", text: "OASIS 350 (25FT - 20 D)", value: "5" },
      { key: "6", text: "SUPRA 1150 (32 FT - 20 D)", value: "6" },
      { key: "7", text: "SUPRA 1250 (34 FT - 20 D)", value: "7" },
      { key: "8", text: "HT-50 MINI (8FT 0 D)", value: "8" },
      { key: "9", text: "HT-100 (8FT -20 D)", value: "9" },
      { key: "10", text: "HT-250 (10FT -20 D)", value: "10" },
      { key: "11", text: "HT-250 SP 2 (20FT -20 D)", value: "11" },
      { key: "12", text: "HT-350 SP 2 (24FT -20 D)", value: "12" },
      { key: "13", text: "HT- 70 DWS (32FT -20 D)", value: "13" },
      { key: "14", text: "C150E (8FT-0 D)", value: "14" },
      { key: "15", text: "C250E (10FT-0 D)", value: "15" },
      { key: "16", text: "C350E (12FT-0 D)", value: "16" },
      { key: "17", text: "C450E (17FT-0D)", value: "17" },
      { key: "18", text: "V300 MAX 10 (8FT-20 D)", value: "18" },
      { key: "19", text: "V300 MAX 20 (8FT-20 D WITH STAND BY)", value: "19" },
      { key: "20", text: "V500 MAX 10 (10FT-20 D)", value: "20" },
      { key: "21", text: "V500 MAX 20 (10FT-20 D WITH STAND BY)", value: "21" },
      { key: "22", text: "RV 380 MAX 10 (10FT -20 D)", value: "22" },
      { key: "23", text: "RV 580 MAX 10 (12FT -20 D)", value: "23" },
      { key: "24", text: "T-600 (20FT -20 D)", value: "24" },
      { key: "25", text: "T-800 (24FT -20 D)", value: "25" },
      { key: "26", text: "T-1000 (32FT-20 D)", value: "26" },
      { key: "27", text: "T-1200 (34FT -20 D)", value: "27" },
    ];

    return (refer_type = refer_items.map((item, index) => {
      if (reefer_type_and_model == +item.key) {
        refer_type = item.text;
        return refer_type;
      }
    }));
  }

  gettrucktype(truck_type_and_model) {
    let truck_type;
    let truck_items = [
      { key: "1", text: "Dry Container", value: 1 },
      { key: "2", text: "Reefer Container", value: 2 },
      { key: "3", text: "Open Body", value: 3 },
    ];

    return (truck_type = truck_items.map((item, index) => {
      if (truck_type_and_model == +item.key) {
        truck_type = item.text;
        return truck_type;
      }
    }));
  }

  getnetworktype(network_type_and_model) {
    let network_type;
    // let network_items = [
    //   { key: "1", text: "Dry Container", value: 1 },
    //   { key: "2", text: "Reefer Container", value: 2 },
    //   { key: "3", text: "Open Body", value: 3 },
    // ];

    return (network_type = this.state.networkProviderList.map((item, index) => {
      if (network_type_and_model == +item.key) {
        network_type = item.text;
        return network_type;
      }
    }));
  }

  gettrackingtype(tracking_type_and_model) {
    let tracking_type;

    return (tracking_type = this.state.trackingTypeMasterList.map((item, index) => {
      if (tracking_type_and_model == +item.key) {
        tracking_type = item.text;
        return tracking_type;
      }
    }));
  }

  getDiff(actual_date, predicted_date) {
    if (actual_date == null || predicted_date == null) {
      return "NA";
    } else {
      let diff = Math.abs(new Date(actual_date) - new Date(predicted_date));
      let diff2 = Math.floor(diff / 60000);
      let tim = diff2;
      let seconds = +tim * 60;
      let d = Math.floor(seconds / (3600 * 24));
      let h = Math.floor((seconds % (3600 * 24)) / 3600);
      let m = Math.floor((seconds % 3600) / 60);
      let dDisplay = d > 0 ? d + (d == 1 ? " day " : " days ") : "";
      let hDisplay = h > 0 ? h + (h == 1 ? " hr " : " hrs ") : "";
      let mDisplay = m > 0 ? m + (m == 1 ? " min " : " mins ") : "";
      return dDisplay + hDisplay + mDisplay;
    }
  }

  handlePdf = (lrNo) => {
    ReadAxios({
      url: "lr/generatePdf",
      readItems: {
        lrNo: lrNo,
      },
    }).then((response) => {
      let url = response;
      window.open(url, "_blank");
    });
  };

  getOrderDetails = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/shipments/${this.state.shipmentId}`,
    })
      .then((res) => {
        this.setState({
          shipmentDetail: res.data.shipment,
        });
        console.log(this.state.shipmentDetail);
        if (this.state.shipmentDetail) {
          for (const key in this.state.shipmentDetail) {
            if (this.state.shipmentDetail.hasOwnProperty(key)) {
              const element = this.state.shipmentDetail[key];
              this.setState({
                documents: element,
              });
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //   TODO: null handling
  render() {
    const { orderDetail, show_current_bl, blList, serviceType } = this.state;
    const { t } = this.props;
    const documents = this.state.orderDetail;
    const shipmentDetail = this.state.bldocuments;
    const routeDetails = this.state.routeDetails;
    const broadcastDetails = this.state.broadcastDetails;
    const deliveries = this.state.deliveries;
    const order = this.state.order;
    let customer_no = localStorage.getItem("customerNumber");
    let timezone = localStorage.getItem("timezone");
    const fispq_and_fe_docs = this.getDocs("fispq_and_fe");
    const coa_docs = this.getDocs("coa_certificate_of_analysis");

    const downloadDaughterInvoice = (container, deliveryid, documentid) => {
      PdfAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${deliveryid}/container/${container}/documents/${documentid}`,
      })
        .then((res) => {
          console.log("PDF Failure", res);
          if (res.data.status == 1) {
            cogoToast.success("File Downloaded Successfully");
          } else {
            cogoToast.success(res.data.message);
          }
          // let link = res.data;
          // link.setAttribute(link)
        })
        .catch((err) => {
          console.error("fAILURE", err);
          // cogoToast.success(err.message);
        });
    };

    return (
      <React.Fragment>
        <OrderDetailsHeader
          title={t("vr_title") || "Vehicle Reporting"}
          LinkName="/vehicle-reporting"
          hideInterest={true}
          hideReject={true}
          vendor_order_id={orderDetail?.vendor_order_id}
          deliveryDetails={orderDetail?.deliveries}
          disableUpdateDetails={
            orderDetail &&
              orderDetail.allotment_status.allotment_code === "COMPLETE"
              ? true
              : false
          }
          vehicleId={orderDetail ? orderDetail.vehicle_id : ""}
        />
        {orderDetail ? (
          <>
            <div className="pad w3-white small">
              <Grid columns={4} className="ml-2">
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {localStorage.getItem("customerNumber") == 1166
                      ? "Booking No"
                      : t("order_number") || "Order No"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {orderDetail.order_reference_no}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {orderDetail.shipment.movement_type == "Import" ||
                      orderDetail.shipment.movement_type == "Importar"
                      ? t("estimated_on")
                      : t("required_on")}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {localStorage.getItem("customerNumber") != 1122
                      ? moment
                        .parseZone(orderDetail.shipment.required_on)
                        .format("DD-MM-YYYY HH:mm")
                      : moment
                        .parseZone(orderDetail.shipment.required_on)
                        .format("DD-MM-YYYY")}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("route") || "Route"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {routeDetails.source} - {routeDetails.destination}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("movement_type") || "Movement Type"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName  movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {orderDetail.shipment.movement_type}
                  </Header>
                </Grid.Column>

                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("proposed_vehicle_type") || "Proposed Vehicle Type"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {orderDetail.vehicle_type}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("from_location") || "Origin"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {routeDetails.source}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("to_location") || "Destination"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {routeDetails.destination}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("weight") || "Net weight"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {orderDetail.gross_weight ? orderDetail.gross_weight : "NA"}
                  </Header>
                </Grid.Column>

                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("reefer_type_and_model") || "Reefer Type"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {this.getrefertype(orderDetail.reefer_type_and_model)}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("truck_type") || "Truck Type"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {this.gettrucktype(orderDetail.truck_type)}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("number_of_driver") || "Number of Drivers"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {orderDetail.number_of_drivers}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("data_logger_available") || "Data Logger Available"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {orderDetail.data_logger_available ? "Yes" : "No"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {"Data Logger Number"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {orderDetail.data_logger_no}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("red_line_inside_container") || "Red-Line Container"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {orderDetail.red_line_inside_container ? "Yes" : "No"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("gps_available") || "GPS Available"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {orderDetail.gps_available ? "Yes" : "No"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("final_rate") || "Final Rate"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {orderDetail.freight_rate ? orderDetail.freight_rate : "NA"}
                  </Header>
                </Grid.Column>
              </Grid>
            </div>
            {shipmentDetail && shipmentDetail.length > 0 ? (
              <>
                <div className="pad w3-white small">
                  <Header
                    as="h5"
                    dividing
                    className="m-2 ml-4 mb-4 p-bold-600 small"
                  >
                    {t("document_upload") || "Documents"}
                    {show_current_bl ? (
                      <Dropdown
                        defaultValue={show_current_bl}
                        options={blList}
                        className="ml-5"
                        name="current_bl_index"
                        onChange={(name, data) => {
                          this.setCurrentBLToShow(name, data);
                        }}
                      />
                    ) : null}
                  </Header>

                  <Grid columns={4} className="ml-2">
                    {this.getDocType("mother_invoice") ? (
                      <>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("document.mother_invoice") || "Mother Invoice"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Button
                            size="mini"
                            basic
                            type="button"
                            onClick={() =>
                              this.downloadFile(this.getDocId("mother_invoice"))
                            }
                            color="primary"
                            icon
                          >
                            <Icon name="download" />
                          </Button>
                          <label> {this.getfileName("mother_invoice")}</label>
                        </Grid.Column>
                      </>
                    ) : null}

                    {this.getDocType("original_bl") ? (
                      <>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("document.original_bl") || "Original BL"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Button
                            size="mini"
                            basic
                            type="button"
                            onClick={() =>
                              this.downloadFile(this.getDocId("original_bl"))
                            }
                            color="primary"
                            icon
                          >
                            <Icon name="download" />
                          </Button>
                          <label> {this.getfileName("original_bl")}</label>
                        </Grid.Column>
                      </>
                    ) : null}

                    {this.getDocType("proof_of_id") ? (
                      <>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("document.proof_of_dI") || "Proof of DI"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Button
                            size="mini"
                            basic
                            type="button"
                            onClick={() =>
                              this.downloadFile(this.getDocId("proof_of_id"))
                            }
                            color="primary"
                            icon
                          >
                            <Icon name="download" />
                          </Button>
                          <label> {this.getfileName("proof_of_id")}</label>
                        </Grid.Column>
                      </>
                    ) : null}

                    {this.getDocType("inv_invoice") ? (
                      <>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("document.INV_invoice") || "INV - Invoice"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Button
                            size="mini"
                            basic
                            type="button"
                            onClick={() =>
                              this.downloadFile(this.getDocId("inv_invoice"))
                            }
                            color="primary"
                            icon
                          >
                            <Icon name="download" />
                          </Button>
                          <label> {this.getfileName("inv_invoice")}</label>
                        </Grid.Column>
                      </>
                    ) : null}

                    {this.getDocType("exoneration") ? (
                      <>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("document.exoneration") || "Exoneration"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Button
                            size="mini"
                            basic
                            type="button"
                            onClick={() =>
                              this.downloadFile(this.getDocId("exoneration"))
                            }
                            color="primary"
                            icon
                          >
                            <Icon name="download" />
                          </Button>
                          <label> {this.getfileName("exoneration")}</label>
                        </Grid.Column>
                      </>
                    ) : null}

                    {this.getDocType("packing_list") ? (
                      <>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("document.packing_list") || "Packing List"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Button
                            size="mini"
                            basic
                            type="button"
                            onClick={() =>
                              this.downloadFile(this.getDocId("packing_list"))
                            }
                            color="primary"
                            icon
                          >
                            <Icon name="download" />
                          </Button>
                          <label> {this.getfileName("packing_list")}</label>
                        </Grid.Column>
                      </>
                    ) : null}

                    {this.getDocType("failure_extract") ? (
                      <>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("document.failure_extract") || "Failure Extract"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Button
                            size="mini"
                            basic
                            type="button"
                            onClick={() =>
                              this.downloadFile(
                                this.getDocId("failure_extract")
                              )
                            }
                            color="primary"
                            icon
                          >
                            <Icon name="download" />
                          </Button>
                          <label> {this.getfileName("failure_extract")}</label>
                        </Grid.Column>
                      </>
                    ) : null}

                    {coa_docs.length > 0 ? (
                      <>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("document.coa") || "COA"}
                          </Header>
                        </Grid.Column>

                        <Grid.Column width={4}>
                          {coa_docs.map((object, i) => (
                            <>
                              <Button
                                size="mini"
                                basic
                                type="button"
                                onClick={() => this.downloadFile(object["id"])}
                                color="blue"
                                key={i}
                                icon
                              >
                                <Icon name="download" />
                              </Button>
                              <label> {object["name"]} </label>
                              <br />
                            </>
                          ))}
                        </Grid.Column>
                      </>
                    ) : null}

                    {this.getDocType("bd_shipment_database") ? (
                      <>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("document.shipment_database") ||
                              "BD - Shipment Database"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Button
                            size="mini"
                            basic
                            type="button"
                            onClick={() =>
                              this.downloadFile(
                                this.getDocId("bd_shipment_database")
                              )
                            }
                            color="primary"
                            icon
                          >
                            <Icon name="download" />
                          </Button>
                          <label>
                            {" "}
                            {this.getfileName("bd_shipment_database")}
                          </label>
                        </Grid.Column>
                      </>
                    ) : null}

                    {this.getDocType("excel_request_for_collection") ? (
                      <>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("document.excel_request_for_collection") ||
                              "Excel (Request for Collection)"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Button
                            size="mini"
                            basic
                            type="button"
                            onClick={() =>
                              this.downloadFile(
                                this.getDocId("excel_request_for_collection")
                              )
                            }
                            color="primary"
                            icon
                          >
                            <Icon name="download" />
                          </Button>
                          <label>
                            {" "}
                            {this.getfileName("excel_request_for_collection")}
                          </label>
                        </Grid.Column>
                      </>
                    ) : null}

                    {this.getDocType("di") ? (
                      <>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("document.di") || "DI"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Button
                            size="mini"
                            basic
                            type="button"
                            onClick={() =>
                              this.downloadFile(this.getDocId("di"))
                            }
                            color="primary"
                            icon
                          >
                            <Icon name="download" />
                          </Button>
                          <label> {this.getfileName("di")}</label>
                        </Grid.Column>
                      </>
                    ) : null}

                    {fispq_and_fe_docs.length > 0 ? (
                      <>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("document.FISPQ_and_FE") || "FISPQ and FE"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          {fispq_and_fe_docs.map((object, i) => (
                            <>
                              <Button
                                size="mini"
                                basic
                                type="button"
                                onClick={() => this.downloadFile(object["id"])}
                                color="blue"
                                key={i}
                                icon
                              >
                                <Icon name="download" />
                              </Button>
                              <label> {object["name"]} </label>
                              <br />
                            </>
                          ))}
                        </Grid.Column>
                      </>
                    ) : null}
                  </Grid>
                </div>
              </>
            ) : null}
            {deliveries ? (
              <div className="pad w3-white small">
                <DeliveryDetailComponentRebuilt
                  deliveries={deliveries}
                  t={t}
                  orderDetail={orderDetail}
                  getOrderDetails={this.getOrderDetails}
                  vehicleReporting={true}
                  serviceType={serviceType}
                  {...this.props}
                />
              </div>
            ) : (
              ""
            )}
            {orderDetail?.vehicle_number ? (
              <>
                <div className="pad w3-white small">

                  {<h4 style={{ paddingLeft: "20px", paddingBottom: "20px" }}>Vehicle Details</h4>}

                  <Grid columns={4} className="ml-2">
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {/* {localStorage.getItem("customerNumber") == 1166
                        ? "Booking No"
                        : t("order_number") || "Order No"} */}
                        {Headings.VEHICLE_NUMBER}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {/* {orderDetail.order_reference_no} */}
                        {orderDetail.vehicle_number
                          ? orderDetail.vehicle_number
                          : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {/* {orderDetail.shipment.movement_type == "Import" ||
                      orderDetail.shipment.movement_type == "Importar"
                        ? t("estimated_on")
                        : t("required_on")} */}
                        {Headings.VEHICLE_TYPE}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {/* {localStorage.getItem("customerNumber") != 1122
                        ? moment
                            .parseZone(orderDetail.shipment.required_on)
                            .format("DD-MM-YYYY HH:mm")
                        : moment
                            .parseZone(orderDetail.shipment.required_on)
                            .format("DD-MM-YYYY")} */}
                        {orderDetail.actual_vehicle_type
                          ? orderDetail.actual_vehicle_type
                          : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {/* {t("route") || "Route"} */}
                        {Headings.OWNERSHIP_TYPE}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {/* {routeDetails.source} - {routeDetails.destination} */}
                        {orderDetail.ownership_type_name
                          ? orderDetail.ownership_type_name
                          : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {/* {t("movement_type") || "Movement Type"} */}
                        {Headings.TRUCK_TYPE}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName  movement_type"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {orderDetail.truck_type
                          ? this.gettrucktype(orderDetail.truck_type)
                          : "NA"}
                      </Header>
                    </Grid.Column>

                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {/* {t("proposed_vehicle_type") || "Proposed Vehicle Type"} */}
                        GPS Available
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName movement_type"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {/* {orderDetail.vehicle_type} */}
                        {orderDetail.gps_available ? "Yes" : "No"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {/* {t("from_location") || "Origin"} */}
                        {Headings.TRACKING_TYPE}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName movement_type"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {/* {routeDetails.source} */}
                        {/* {orderDetail.tracking_type} */}

                        {orderDetail.tracking_type
                          ? this.gettrackingtype(orderDetail.tracking_type)
                          : "NA"}
                      </Header>
                    </Grid.Column>

                    {/* <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                     
                      Vehicle Registration Date
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName movement_type"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                     
                      {"Na"}
                    </Header>
                  </Grid.Column>

                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      PUC Expiry Date
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName movement_type"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                     
                      {"Na"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                   
                      Insurance Expiry Date
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName movement_type"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                    
                      {"Na"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                     
                      Permit Expiry Date
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName movement_type"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                     
                      {"Na"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                   
                      Road Tax Expiry Date
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName movement_type"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                  
                      {"Na"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                    
                      Fitness Expiry Date
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName movement_type"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      
                      {"Na"}
                    </Header>
                  </Grid.Column> */}

                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {/* {t("gps_available") || "GPS Available"} */}
                        {Headings.NO_OF_DRIVERS}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName movement_type"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {/* {orderDetail.gps_available ? "Yes" : "No"} */}
                        {orderDetail.number_of_drivers
                          ? orderDetail.number_of_drivers
                          : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {/* {t("final_rate") || "Final Rate"} */}
                        {Headings.DRIVER_NAME}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {/* {orderDetail.freight_rate
                        ? orderDetail.freight_rate
                        : "NA"} */}
                        {orderDetail.driver_name ? orderDetail.driver_name : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {/* {t("final_rate") || "Final Rate"} */}
                        {Headings.DRIVER_MOBILE_NUMBER}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {/* {orderDetail.freight_rate
                        ? orderDetail.freight_rate
                        : "NA"} */}
                        {orderDetail.driver_number ? orderDetail.driver_number : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {/* {t("final_rate") || "Final Rate"} */}
                        {Headings.DRIVER_LICENCE_NUMBER}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {/* {orderDetail.freight_rate
                        ? orderDetail.freight_rate
                        : "NA"} */}
                        {orderDetail.driver_lic_no ? orderDetail.driver_lic_no : "NA"}
                      </Header>
                    </Grid.Column>
                    {Number(localStorage.getItem('customerNumber')) !== 1122 ?
                      <>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {/* {t("final_rate") || "Final Rate"} */}
                            {Headings.NETWORK_PROVIDER}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {/* {orderDetail.freight_rate
                        ? orderDetail.freight_rate
                        : "NA"} */}
                            {orderDetail.network_provider_id
                              ? this.getnetworktype(orderDetail.network_provider_id)
                              : "NA"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {/* {t("final_rate") || "Final Rate"} */}
                            {Headings.VEHICLE_SEAL_NUMBER}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {/* {orderDetail.freight_rate
                        ? orderDetail.freight_rate
                        : "NA"} */}
                            {orderDetail.vehicle_seal_no
                              ? orderDetail.vehicle_seal_no
                              : "NA"}
                          </Header>
                        </Grid.Column>
                      </>
                      : null}
                    {/* <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      
                      Driver Licence Expiry Date
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}> 
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                     
                      {"NA"}
                    </Header>
                      </Grid.Column>*/}
                  </Grid>
                </div>
              </>
            ) : (
              ""
            )}

            {/* End OF Vehicle Detail section */}

            {/* {deliveries ? (deliveries.map((deliveries, i) => (
              <div className="pad w3-white small">
                <Grid columns={4} className="ml-2 mt-1">
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-600 labelName small"
                      size="medium"
                      as="label"
                    >
                      {t("delivery_details") || "Delivery Details"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={10}>
                    <Grid.Row style={{ float: "right", paddingRight: "2%" }}>
                      {(orderDetail.shipment.movement_type == "Import" || orderDetail.shipment.movement_type == "Importar") && customer_no == 1122 ?
                        <>
                          <FormikPickup delivery_id={deliveries ? deliveries.delivery_id : "NA"} delivery_status={deliveries ? (deliveries.delivery_status ? deliveries.delivery_status.delivery_code : "NA") : "NA"}
                            delivery_text={deliveries ? (deliveries.delivery_status ? deliveries.delivery_status.delivery_text : "NA") : "NA"} movement_type={orderDetail.shipment.movement_type} delivery_details={deliveries ? deliveries : "NA"} />
                          <FormikDropDetails t={t} delivery_id={deliveries ? deliveries.delivery_id : "NA"}
                            drop_location={deliveries.drop_location ? deliveries.drop_location : ""}
                            delivery_status={deliveries ? (deliveries.delivery_status ? deliveries.delivery_status.delivery_code : "NA") : "NA"}
                            delivery_details={deliveries ? deliveries : "NA"}
                          />
                        </>
                        :
                        <>
                          <FormikStatusChange movement_type={orderDetail.shipment.movement_type} delivery_id={deliveries ? deliveries.delivery_id : "NA"}
                            delivery_status={deliveries ? (deliveries.delivery_status ? deliveries.delivery_status.delivery_code : "NA") : "NA"}
                            delivery_status_id={deliveries ? (deliveries.delivery_status ? deliveries.delivery_status.delivery_status_id : "NA") : "NA"}
                            delivery_time={deliveries ? (deliveries.delivery_status ? deliveries.delivery_status.status_timestamp : "NA") : "NA"}
                          />
                          <Button
                            type="button"
                            onClick={() => this.handleHistoryModal(deliveries)}
                            size="mini"
                            color="blue"
                            className="mr-2"
                            basic
                            icon
                          >
                            <Icon name="time" />
                            &nbsp;Status History
                          </Button>

                        </>
                      }
                    </Grid.Row>
                  </Grid.Column>
                  {customer_no != 1122 ?
                    <>
                      <Grid.Column width={2}>
                        <Grid.Row>
                          <Button
                            hidden={deliveries && deliveries.is_delivered === 1 ? true : false}
                            type="button"
                            onClick={this.handlePodModal}
                            size="mini"
                            color="blue"
                            className="mr-2"
                            basic
                            icon
                          >
                            <Icon name="plus" />&nbsp;PoD
                          </Button>
                          <Button
                            type="button"
                            hidden={deliveries && deliveries.is_delivered === 1 ? false : true}
                            onClick={this.handleViewPodModal}
                            size="mini"
                            color="green"
                            className="ml-2 mr-2"
                            basic
                            icon
                          >
                            <Icon name="eye" />&nbsp;PoD
                          </Button>
                          <AddPod {...this.props} deliveryDetails={this.state.deliveryDetails} orders={this.state.orderDetail} mode="create" open={this.state.podModal} onClose={() => this.setState({ podModal: false })} />
                          <ViewPod {...this.props} deliveryDetails={this.state.deliveryDetails} viewPod={this.state.viewPodModal} orders={this.state.orderDetail} viewPodModalClose={() => this.setState({ viewPodModal: false })} />
                        </Grid.Row>
                      </Grid.Column>
                    </>
                    : ""}

                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("delivery_number") || "Delivery Number"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {deliveries ? deliveries.delivery_reference_no : "NA"}

                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("vendor_lr_no") || "LR No."}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {deliveries ? (deliveries.transporter_lr_no ? deliveries.transporter_lr_no : "NA") : "NA"}
                    </Header>
                    <Button 
                      onClick={() =>  this.setState({ vendorLrNoModal: true })}
                      icon
                      size="mini"
                      basic
                      className="ml-2"
                    >
                        <Icon name="edit" color="green"></Icon>
                    </Button>
                    <Button 
                      onClick={() =>  this.handlePdf(deliveries.delivery_reference_no)}
                      icon
                      size="mini"
                      basic
                      className="ml-2"
                    >
                        <Icon name="file pdf" color="red"></Icon>
                    </Button>
                    <EditVendorLrNoModal 
                      closeEditVendorLrNoModal={() => this.setState({ vendorLrNoModal: false})}
                      openEditVendorLrNoModal={this.state.vendorLrNoModal}
                      vendorLrNo={deliveries.transporter_lr_no ? deliveries.transporter_lr_no : ""}
                      deliveryId={deliveries.common_delivery_id}
                    />
                  </Grid.Column>

                  {orderDetail.shipment.movement_type == "Import" || orderDetail.shipment.movement_type == "Importar" ?
                    <>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("portterminal") || "Port Terminal"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {deliveries ? (deliveries.consignor ? deliveries.consignor.consignor_address : "NA") : "NA"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("delivery_location") || "Delivery Location"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {deliveries ? (deliveries.consignee ? deliveries.consignee.consignee_address : "NA") : "NA"}
                        </Header>
                      </Grid.Column>

                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("import_decleration_number") || "Import Declaration No."}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-500 labelName movement_type"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {deliveries.import_declaration_no ? deliveries.import_declaration_no : "NA"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("boarding_no") || "Boarding No."}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-500 labelName movement_type"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {deliveries.boarding_no ? deliveries.boarding_no : "NA"}
                        </Header>
                      </Grid.Column>

                      {deliveries.products && localStorage.getItem('customerNumber') != 1122 ? deliveries.products.map((products, i) => (
                        <>
                          <Grid.Column width={3}>
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("packaging_type") || "Packaging Type Name"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="black"
                            >
                              {products ? (products.packaging_type_name ? products.packaging_type_name : "NA") : "NA"}
                            </Header>
                          </Grid.Column>
                        </>
                      )) : ""}
                      {deliveries.products && localStorage.getItem('customerNumber') != 1122 ? deliveries.products.map((products, i) => (
                        <>
                          <Grid.Column width={3}>
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("product_name") || "Product Category Name"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="black"
                            >
                              {products ? (products.product_category_name ? products.product_category_name : "NA") : "NA"}
                            </Header>
                          </Grid.Column>
                        </>
                      )) : ""}
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("storage_expiration") || "Storage Expiration"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {deliveries ? (deliveries.storage_expiration_date ? moment.parseZone(deliveries.storage_expiration_date).format('DD-MM-YYYY') : "NA") : "NA"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("container_type") || "Container Type"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {deliveries ? (deliveries.container_type ? deliveries.container_type : "NA") : "NA"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {
                            localStorage.getItem('customerNumber') == 1327 & (orderDetail.shipment.movement_type === "Import" || orderDetail.shipment.movement_type === "Export") ? t("do_no_expiration") || "DO No. Expiration"
                              : <>
                                {t("demurrage_expiration") || "Demurrage Expiration"}
                              </>
                          }

                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {deliveries ? (deliveries.demurrage_expiration_date ? moment.parseZone(deliveries.demurrage_expiration_date).format('DD-MM-YYYY') : "NA") : "NA"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("container_number") || "Container Number"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {deliveries ? (deliveries.container_no ? deliveries.container_no : "NA") : "NA"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("ata") || "ETA"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {deliveries ? (deliveries.ata_date ? moment.parseZone(deliveries.ata_date).format('DD-MM-YYYY') : "NA") : "NA"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("container_drop_location") || "Container Drop Location"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {deliveries ? (deliveries.drop_location ? deliveries.drop_location : "NA") : "NA"}
                        </Header>
                      </Grid.Column>
                    </>
                    : <>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("consignor_city") || "Consignor City"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {deliveries ? (deliveries.consignor ? (deliveries.consignor.consignor_city ? deliveries.consignor.consignor_city : "NA") : "NA") : "NA"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("consignee_city") || "Consignee City"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {deliveries ? (deliveries.consignee ? (deliveries.consignee.consignee_city ? deliveries.consignee.consignee_city : "NA") : "NA") : "NA"}
                        </Header>
                      </Grid.Column>


                      {localStorage.getItem('customerNumber') != 1122 ?
                        (<>
                          <Grid.Column width={3}>
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("packaging_type") || "Packaging Type Name"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="black"
                            >
                              {deliveries ? (deliveries.products.packaging_type_name ? deliveries.products.packaging_type_name : "NA") : "NA"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={3}>
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("product_name") || "Product Category Name"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="black"
                            >
                              {deliveries ? (deliveries.products.product_category_name ? deliveries.products.product_category_name : "NA") : "NA"}
                            </Header>
                          </Grid.Column>
                        </>) : ""}

                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("pickuplocation") || "Pickup Location"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {deliveries ? (deliveries.consignor ? deliveries.consignor.consignor_address : "NA") : "NA"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("deliveryLocation") || "Drop Location"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {deliveries ? (deliveries.consignee ? deliveries.consignee.consignee_address : "NA") : "NA"}                      </Header>
                      </Grid.Column>
                      {deliveries ? (deliveries.max_temp ?
                        <>
                          <Grid.Column width={3}>
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("temp_min") || "Temperature Minimum"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="black"
                            >
                              {deliveries ? deliveries.min_temp + '\u00b0' + "C" : "NA"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={3}>
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("temp_max") || "Temperature Maximum"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="black"
                            >
                              {deliveries ? deliveries.max_temp + '\u00b0' + "C" : "NA"}
                            </Header>
                          </Grid.Column>
                        </>
                        : "")
                        : ""}
                    </>
                  }
                  <Grid.Row style={{ marginLeft: "0" }}>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {
                          localStorage.getItem('customerNumber') == 1327 & (orderDetail.shipment.movement_type === "Import" || orderDetail.shipment.movement_type === "Export") ?
                            <> {t("scheduled_requested_stuffing") || "Scheduled requested stuffing Date & Time"}</>
                            : <>
                              {t("pickup_date") || "Drop Location"}
                            </>
                        }

                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {deliveries ? (deliveries.container_pickup_date ? moment.parseZone(deliveries.container_pickup_date).format('DD-MM-YYYY HH:mm') : "NA") : "NA"}
                      </Header>
                    </Grid.Column>
                    {deliveries ? (deliveries.actual_pickup_date ?
                      <>

                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >

                            {
                              localStorage.getItem('customerNumber') == 1327 & (orderDetail.shipment.movement_type === "Import" || orderDetail.shipment.movement_type === "Export") ?
                                <> {t("actual_requested_stuffing") || "Actual requested stuffing Date & Time"}</>
                                : <>
                                  {t("actual_pick") || "Actual Pickup Date"}
                                </>
                            }


                          </Header>
                        </Grid.Column>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="black"
                          >
                            {deliveries ? (deliveries.actual_pickup_date ? moment.parseZone(deliveries.actual_pickup_date).format('DD-MM-YYYY HH:mm') : "NA") : "NA"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={1}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("Difference") || "Difference"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName ml-4"
                            size="tiny"
                            as="label"
                            color="red"
                          >
                            {this.getDiff(deliveries.actual_pickup_date, deliveries.container_pickup_date)}
                          </Header>
                        </Grid.Column>
                      </>
                      : "") : ""}
                  </Grid.Row>
                  <Grid.Row style={{ marginLeft: "0" }}>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("delivery_date") || "Delivery Date & Time"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {deliveries ? (deliveries.delivery_date ? moment.parseZone(deliveries.delivery_date).format('DD-MM-YYYY HH:mm') : "NA") : "NA"}
                      </Header>
                    </Grid.Column>
                    {deliveries ? (deliveries.actual_delivery_date ?
                      <>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("actual_delivery") || "Actual Delivery Date"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="black"
                          >
                            {deliveries ? (deliveries.actual_delivery_date ? moment.parseZone(deliveries.actual_delivery_date).format('DD-MM-YYYY HH:mm') : "NA") : "NA"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={1}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("Difference") || "Difference"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName ml-4"
                            size="tiny"
                            as="label"
                            color="red"
                          >
                            {this.getDiff(deliveries.actual_delivery_date, deliveries.delivery_date)}
                          </Header>
                        </Grid.Column>
                      </>
                      : "") : ""}
                  </Grid.Row>
                  {orderDetail.shipment.movement_type == "Import" || orderDetail.shipment.movement_type == "Importar" ?
                    <>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("drop_date") || "Drop Date"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {deliveries ? (deliveries.container_return_date ? moment.parseZone(deliveries.container_return_date).format('DD-MM-YYYY HH:mm') : "NA") : "NA"}
                        </Header>
                      </Grid.Column>
                      {deliveries ? (deliveries.actual_container_return_date ?
                        <>
                          <Grid.Column width={3}>
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("actual_drop") || "Actual Drop Date"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={3}>
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="black"
                            >
                              {deliveries ? (deliveries.actual_container_return_date ? moment.parseZone(deliveries.actual_container_return_date).format('DD-MM-YYYY HH:mm') : "NA") : "NA"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={1}>
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("Difference") || "Difference"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={3}>
                            <Header
                              className="p-bold-600 labelName ml-4"
                              size="tiny"
                              as="label"
                              color="red"
                            >
                              {this.getDiff(deliveries.actual_container_return_date, deliveries.container_return_date)}
                            </Header>
                          </Grid.Column>
                        </>
                        : "") : ""}
                    </>
                    : ""}
                  {
                    deliveries && deliveries.daughter_invoice ?
                      (<>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-600 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("Daughter Invoice") || "Daughter Invoice"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Button size="mini"
                            basic type="button"
                            onClick={() => downloadDaughterInvoice(deliveries.container_no, deliveries.daughter_invoice.delivery_id, deliveries.daughter_invoice.document_id)}
                            color="primary"
                            icon>
                            <Icon name="download" />
                          </Button>
                          <label> {deliveries.daughter_invoice.document_name}</label>
                        </Grid.Column>

                      </>)
                      :
                      ""
                  }

                </Grid>
              </div>
            ))) : ''} */}
            {this.state.historyModal && (
              <StatusHistory
                {...this.props}
                delivery_id={this.state.deliverySD.delivery_id}
                open={this.state.historyModal}
                onClose={() => this.setState({ historyModal: false })}
              />
            )}
            {broadcastDetails ? (
              <div className="pad w3-white small">
                <Header as="h5" dividing className="m-2 mb-4 p-bold-600 small">
                  {t("broadcast_details") || "Broadcast Details"}
                </Header>
                <Grid columns={4} className="ml-2">
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("broadcast_start") || "Broadcast Start Date & Time"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {moment
                        .parseZone(broadcastDetails.broadcast_start_datetime)
                        .format("DD-MM-YYYY HH:mm")}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("broadcast_end") || "Broadcast End Date & Time"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {moment
                        .parseZone(broadcastDetails.broadcast_end_datetime)
                        .format("DD-MM-YYYY HH:mm")}
                    </Header>
                  </Grid.Column>

                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("offered_rate") || "Offered Rate"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {broadcastDetails.base_rate}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("uom") || "Uom"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {broadcastDetails.uom}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("return_load") || "Return Load"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {broadcastDetails.return_load == true
                        ? t("available") || "Available"
                        : t("not_available") || "Not Available"}
                    </Header>
                  </Grid.Column>
                  {localStorage.getItem('customerNumber') == "2" ?
                    <>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("loading_done_by.title") || "Loading Done By"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {broadcastDetails.loading_done_by}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("loading_charges.title") || "Loading Charges"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {broadcastDetails.loading_charges}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("unloading_done_by.title") || "Unloading Done By"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {broadcastDetails.unloading_done_by}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("unloading_charges.title") || "Unloading Charges"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {broadcastDetails.unloading_charges}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("insured_by.title") || "Insured By"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {broadcastDetails.insured_by}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("advance_payment.title") || "Advance Payment"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {broadcastDetails.advance_payment}%
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {t("credit_period_for_settlement.title") || "Credit Period For Settlement"}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-600 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {broadcastDetails.credit_period_for_settlement}
                        </Header>
                      </Grid.Column>
                    </>
                    : null}
                </Grid>
              </div>
            ) : null}
          </>
        ) : (
          <LoadingPlaceholder />
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ auth, permissions }) => {
  return {
    permissions,
    auth,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    success: (alert) => dispatch(successAlertDispatcher(alert)),
    error: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("order_details")(ReportingOrderDetails));
